import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id BE45DEDF-3BBC-442F-9EDD-4A16570B91A0
 * name account-school
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-school.svg
 * tags
 * - Account / User 
 */
export const AccountSchoolIcon = createSvgIcon(<><path d="M16 8C16 10.21 14.21 12 12 12C9.79 12 8 10.21 8 8L8.11 7.06L5 5.5L12 2L19 5.5V10.5H18V6L15.89 7.06L16 8M12 14C16.42 14 20 15.79 20 18V20H4V18C4 15.79 7.58 14 12 14Z" /></>, 'AccountSchoolIcon');
export default AccountSchoolIcon